import { SSPA } from "../constants/sspa";

export class OverlayService {
  private static overlayService: OverlayService;

  private constructor() {}

  static singleton(): OverlayService {
    if (!OverlayService.overlayService) {
      OverlayService.overlayService = new OverlayService();
    }
    return OverlayService.overlayService;
  }

  toggle() {
    const overlay: HTMLElement = document.querySelector(SSPA.overlay);
    overlay.classList.toggle("show");
  }

  remove() {
    const overlay: HTMLElement = document.querySelector(SSPA.overlay);
    overlay.classList.remove("show");
  }
}
